import { Created, Updated, Deleted } from "./common";
import { IssueAdminEntityPermittedAction } from "./IssueAdminEntity";

export enum IssueCustomAttributeType {
  Numeric = "numeric",
  Date = "date",
  Checkbox = "checkbox",
  Paragraph = "paragraph",
  List = "list",
  Text = "text",
}

export interface IssueCustomAttributeDefinitionCommon
  extends Created,
    Updated,
    Deleted {
  id: string;
  containerId: string;
  title: string;
  description: string;
  dataType: IssueCustomAttributeType;
  isRequiredDefault: boolean;
  permittedActions: IssueAdminEntityPermittedAction[];
  permittedAttributes: (
    | "title"
    | "description"
    | "isRequiredDefault"
    | "metadata"
  )[];
}

export interface IssueCustomNumericAttributeDefinition
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.Numeric;
  metadata?: {
    numeric?: {
      min?: number;
      max?: number;
    };
  };
}

export interface IssueCustomDateAttributeDefinition
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.Date;
  metadata?: {
    date?: {
      min?: string;
      max?: string;
    };
  };
}

export interface IssueCustomCheckboxAttributeDefiniton
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.Checkbox;
  metadata?: {};
}

export interface IssueCustomParagraphAttributeDefinition
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.Paragraph;
  metadata?: {
    paragraph?: {
      minLength: number;
      maxLength: number;
    };
  };
}

export interface IssueListCustomAttributeOption {
  id: string;
  value: string;
}

export interface IssueCustomListAttributeDefinition
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.List;
  metadata: {
    list: {
      options: IssueListCustomAttributeOption[];
    };
  };
}

export interface IssueCustomTextAttributeDefinition
  extends IssueCustomAttributeDefinitionCommon {
  dataType: IssueCustomAttributeType.Text;
  metadata?: {
    text: {
      minLength: number;
      maxLength: number;
    };
  };
}

export type IssueCustomAttributeDefinition =
  | IssueCustomNumericAttributeDefinition
  | IssueCustomDateAttributeDefinition
  | IssueCustomCheckboxAttributeDefiniton
  | IssueCustomParagraphAttributeDefinition
  | IssueCustomListAttributeDefinition
  | IssueCustomTextAttributeDefinition;

export interface IssueCustomAttributeDefinitionAttributesCommon {
  title: string;
  description?: string;
  //TODO: allow date and checkbox custom fields once they are added
  dataType:
    | IssueCustomAttributeType.Text
    | IssueCustomAttributeType.List
    | IssueCustomAttributeType.Paragraph
    | IssueCustomAttributeType.Numeric;
  isRequiredDefault?: boolean;
}

export interface IssueTextCustomAttributeDefinitionAttributes
  extends IssueCustomAttributeDefinitionAttributesCommon {
  dataType: IssueCustomAttributeType.Text;
  metadata?: {
    text?: {
      minLength?: number;
      maxLength?: number;
    };
  };
}

export interface IssueListCustomAttributeOptionAttributes {
  value: string;
}

export interface IssueListCustomAttributeDefinitionAttributes
  extends IssueCustomAttributeDefinitionAttributesCommon {
  dataType: IssueCustomAttributeType.List;
  metadata: {
    list: {
      options: IssueListCustomAttributeOptionAttributes[];
    };
  };
}

export interface IssueParagraphCustomAttributeDefinitionAttributes
  extends IssueCustomAttributeDefinitionAttributesCommon {
  dataType: IssueCustomAttributeType.Paragraph;
  metadata?: {
    paragraph?: {
      minLength?: string;
      maxLength?: string;
    };
  };
}

export interface IssueNumericCustomAttributeDefinitionAttributes
  extends IssueCustomAttributeDefinitionAttributesCommon {
  dataType: IssueCustomAttributeType.Numeric;
  metadata?: {
    numeric?: {
      min?: number;
      max?: number;
    };
  };
}

export type IssueCustomAttributeDefinitionAttributes =
  | IssueTextCustomAttributeDefinitionAttributes
  | IssueListCustomAttributeDefinitionAttributes
  | IssueParagraphCustomAttributeDefinitionAttributes
  | IssueNumericCustomAttributeDefinitionAttributes;
